import { Link } from 'react-router-dom';
import './Footer.css';
import logoImage from '../assets/images/bca-ventures-logo.png';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <img
            className="footer-logo-mark"
            src={logoImage}
            alt="BCA Ventures"
          />

          <p className="footer-tagline">
            Strategic Technology Advisory, AI Solutions for Technology &amp;
            Digital Marketing, Applications, Digital Content Development &amp;
            Management, AI Technology Solutions
          </p>
        </div>

        <div className="footer-divider" />

        <nav className="footer-nav-row">
          <Link to="/">Home</Link>
          <Link to="/about-us">About Us</Link>
          <Link to="/contact-us">Contact Us</Link>
        </nav>

        <div className="footer-bottom-row">
          <p className="footer-copyright">
            &copy; {year} BCA Ventures LLC &middot; registered in the United
            States &middot; imagery used under license.
          </p>
          <div className="footer-legal-links">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms-and-conditions">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
